import { FC } from "react";
import Image from "next/image";
import { SmallImageBlock } from "@/api/generated-api";
import S from "./index.module.scss";
import clsx from "clsx";

interface ITechnologySmallImage {
  data: SmallImageBlock;
}

const TechnologySmallImage: FC<ITechnologySmallImage> = ({ data }) => {
  const { reverse, image, content } = data;

  return (
    <div className={S.block}>
      <div className={clsx(S.imageContainer, { [S["imageContainer--reverse"]]: reverse })}>
        <Image width={660} height={480} src={image} alt="technology" />
      </div>
      {content && (
        <div
          className={clsx(S.content, { [S["content--reverse"]]: reverse })}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </div>
  );
};

export default TechnologySmallImage;
